
import { LightningElement, api} from 'lwc';
import { getLabelsByLanguage } from '../../../utils/languageUtil';


function getValue(value) {
    if (!value) return 'Outdoor';

    if (value === 'Indoor') {
        return 'Indoor';
    }

    return 'Outdoor';
}

const ACTIVE_CL = "gw-toggle-btn is-active";
const INACTIVE_CL = "gw-toggle-btn";


export default class gwTabButtonToggle extends LightningElement {
    _outdoorCl = "gw-toggle-btn is-active";
    _indoorCl = "gw-toggle-btn";
    

    labelOutdoor = getLabelsByLanguage('Outdoor');
    labelIndoor = getLabelsByLanguage('Indoor');
    

    _currentValue = 'Outdoor';
    @api 
    set currentValue(val) {
        this._currentValue = getValue(val);
        this.updateButtonStates(this._currentValue);
    }
    get currentValue() {
        return this._currentValue ?? 'Outdoor'
    }

    @api getValue() {
        return this._currentValue;
    }

    updateButtonStates(value) {

        this._currentValue = value;
        const newVal = this.getValue(value);

        if (newVal === 'Indoor') {
            this._outdoorCl = INACTIVE_CL;
            this._indoorCl = ACTIVE_CL;
            this.dispatchEvent(new CustomEvent('change', { detail: 'Indoor' } ));
        } else {
            this._outdoorCl = ACTIVE_CL;
            this._indoorCl = INACTIVE_CL;
            this.dispatchEvent(new CustomEvent('change', { detail: 'Outdoor' } ));
        }
    }

    handleToggle(event) {
        console.log('in handleToggle of gwTabButtonToggle.js');
        const value = event.currentTarget.dataset.value;
        this.updateButtonStates(value);
    }
}